import superMeta from '../_ALG_CAT/metaAlgCatNode.mjs'

export default {
    ...superMeta,
    algNodeType: 'BDBASE',
    algType: 'BASE',
    name: '业务基础方法',
    type: 'BD_BASE',
}
